'use es6';

import PropTypes from 'prop-types';
import Field from './Field';
import HtmlValidationMessage from './HtmlValidationMessage';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UsernamePassword = ({
  fieldProps,
  isExpanded,
  userFieldName,
  passwordFieldName,
  validationMessages,
  value
}) => /*#__PURE__*/_jsxs(View, {
  margin: 0,
  textAlign: "start",
  children: [/*#__PURE__*/_jsx(Field, Object.assign({}, fieldProps, {
    "aria-hidden": !isExpanded,
    error: Boolean(validationMessages[userFieldName]),
    messageKeySuffix: "customUsernameLabel",
    name: userFieldName,
    validationMessage: /*#__PURE__*/_jsx(HtmlValidationMessage, {
      message: validationMessages[userFieldName]
    }),
    value: value.get(userFieldName)
  })), /*#__PURE__*/_jsx(Field, Object.assign({}, fieldProps, {
    "aria-hidden": !isExpanded,
    error: Boolean(validationMessages[passwordFieldName]),
    messageKeySuffix: "passwordLabel",
    name: passwordFieldName,
    placeholderKeySuffix: "passwordPlaceholder",
    type: "password",
    validationMessage: /*#__PURE__*/_jsx(HtmlValidationMessage, {
      message: validationMessages[passwordFieldName]
    }),
    value: value.get(passwordFieldName)
  }))]
});
UsernamePassword.propTypes = {
  fieldProps: PropTypes.object.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  userFieldName: PropTypes.string.isRequired,
  passwordFieldName: PropTypes.string.isRequired,
  validationMessages: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired
};
export default UsernamePassword;